import styled from 'styled-components'
import { rem } from 'polished'
import { merchandiseMegaMenuBreakpoints } from './merchandiseMegaMenuBreakpoints'

interface MerchandiseMegaMenuPanelProps {
  $fullWidth?: boolean
  $panels?: number
}

const MerchandiseMegaMenuPanel = styled.div<MerchandiseMegaMenuPanelProps>`
  width: ${props => {
    if (props.$fullWidth) return '100%'
    const panels = props.$panels ?? 1
    return rem(480 * panels)
  }};
  height: max-content;

  ${props => !props.$fullWidth && `
    ${merchandiseMegaMenuBreakpoints.ultraWide} {
      max-width: ${rem(410 * (props.$panels ?? 1))};
    }

    ${merchandiseMegaMenuBreakpoints.mediumLarge} {
      max-width: ${rem(320 * (props.$panels ?? 1))};
    }

    ${merchandiseMegaMenuBreakpoints.compact} {
      max-width: ${rem(275 * (props.$panels ?? 1))};
    }

    ${merchandiseMegaMenuBreakpoints.tablet} {
      max-width: ${rem(248 * (props.$panels ?? 1))};
    }
  `}
`

export default MerchandiseMegaMenuPanel
